import { history, batchHistory, continuousHistory } from '@/data-dummy/data-dummy'
import { HistoryState, Item, History, BatchHistory, ContinuousHistory } from './state'
import { ActionContext } from 'vuex'

const databases: Item = {
  check: history,
  batch: batchHistory,
  cck: continuousHistory
}

export const getItemsByTable = function (context: ActionContext<HistoryState, object>, table: string): History[] | BatchHistory[] | ContinuousHistory[] {
  switch (table) {
    case 'check': {
      return context.getters.getCheckItems
    }
    case 'batch': {
      return context.getters.getBatchItems
    }
    case 'cck': {
      return context.getters.getCckItems
    }
  }

  return []
}

export const commitItems = function (context: ActionContext<HistoryState, object>, { table, begin, end }: { table: string; begin: number; end: number; }): void {
  const database = databases[table as keyof Item]

  switch (table) {
    case 'check': {
      const items = context.getters.getCheckItems
      context.commit('setItems', { table, value: items.concat(database.slice(begin, end) as History[]) })
      break
    }
    case 'batch': {
      const items = context.getters.getBatchItems
      context.commit('setItems', { table, value: items.concat(database.slice(begin, end) as BatchHistory[]) })
      break
    }
    case 'cck': {
      const items = context.getters.getCckItems
      context.commit('setItems', { table, value: items.concat(database.slice(begin, end) as ContinuousHistory[]) })
      break
    }
  }
}

export const setHistoryResults = function (context: ActionContext<HistoryState, object>, { table, itemsPerLoad }: { table: string; itemsPerLoad: number; }): void {
  const database = databases[table as keyof Item]
  const databaseLen = database.length
  const items = getItemsByTable(context, table)
  const len = items.length

  if (len === 0) {
    context.commit('setItems', { table, value: database.slice(0, itemsPerLoad) })
    context.commit('setLoad', { table, value: true })

    return
  }

  if (len >= databaseLen) {
    context.commit('setLoad', { table, value: false })
    return
  }

  if (len >= (databaseLen - itemsPerLoad)) {
    commitItems(context, { table, begin: 0, end: len })
    context.commit('setLoad', { table, value: false })

    return
  }

  commitItems(context, { table, begin: len, end: len + itemsPerLoad })
  context.commit('setLoad', { table, value: true })
}
